import { createSlice } from "@reduxjs/toolkit";
import { IChat } from "src/@types/chat";
import { CHAT_SLICE_NAME } from "./actions";
import { getChatReducer } from "./reducers";

export interface ChatState {
  isLoading: boolean;
  data: IChat;
}

const initialState: ChatState = {
  isLoading: false,
  data: null,
};

export const { reducer: chat } = createSlice({
  name: CHAT_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getChatReducer(builder);
  },
});
